// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export enum PanelNames {
    PositionsPanel = 'POSITIONSPANEL',
    OrdersPanel = 'ORDERSPANEL',
    EventsPanel = 'EVENTSPANEL',
    OrderHistoryPanel = 'NAME_ORDERHISTORY_PANEL',
    FilledOrdersPanel = 'NEWTRADESPANEL',
    AssetBalancesPanel = 'ASSET_BALANCES_PANEL',
    InformerPanel = 'INFORMERPANEL',
    AlertPanel = 'ALERTPANEL',
    CreateAlertPanel = 'CREATEALERTPANEL',
    OrderEntry = 'NAME_ORDERCOMPOSIT_PANEL', // с клиента взял
    AdvancedOrderEntry = 'NAME_ADVANCED_ORDER_ENTRY_PANEL',
    ReportsPanel = 'REPORTSPANEL',
    RiskCalculator = 'RISKCALCULATOR',
    ProductsPanel = 'PRODUCTSPANEL',
    TSPanel = 'TRADESPANEL',
    AccountDetailsPanel = 'ACCOUNTDETAILSPANEL',
    SymbolInfoPanel = 'INSTRUMENTDETAILSPANEL',
    InstrumentHolidaysScreen = 'INSTRUMENT_HOLIDAYS_SCREEN',
    MarketDepthPanel = 'LEVEL2PANEL',
    ExternalScreen = 'EXTERNALSCREEN',
    ChartPanel = 'CHARTPANEL',
    TradingViewChartPanel = 'TRADINGVIEW_CHARTPANEL',

    PortfolioTable = 'PORTFOLIOTABLE',
    PortfolioPerformance = 'PORTFOLIOPERFORMANCE',
    PortfolioReturns = 'PORTFOLIORETURNS',
    PortfolioSummary = 'PORTFOLIOSUMMARY',
    MarginOEControl = 'MARGIN_OE_CONTROL',

    TypesManagerScreen = 'TYPES_MANAGER_SCREEN',

    GridPanel = 'GRIDPANEL',
    FullLogsPanel = 'FULLLOGSPANEL',
    SavedOrdersPanel = 'SAVEDORDERSPANEL',
    StatementPanel = 'STATEMENTPANEL',
    TradingCentral = 'TRADINGCENTRAL',
    IdeasPanel = 'TRADINGIDEAS',
    NotificationsPanel = 'NOTIFICATIONSPANEL',
    MultiTimeSalesPanel = 'MULTITIMESALESPANEL',
    AssetsPanel = 'ASSETSPANEL',
    PositionsBalancePanel = 'POSITIONSBALANCEPANEL',
    NewsPanel = 'NEWSPANEL',
    VideoWidget = 'VIDEO_WIDGET',

    AlgorithmMarketConsensusPanel = 'ALGORITHM_MARKET_CONSENSUS_PANEL',
    GainersLosersPanel = 'GAINERS_LOSERS_PANEL',
    HighLowPanel = 'HIGH_LOW_PANEL',

    ClosePositionsMutually = 'CLOSE_POSITIONS_MUTUALLY',
    HeatmapPanel = 'HEATMAP_PANEL',

    MamSummary = 'MAM_SUMMARY',
}

export const PanelLocKeys = {
    [PanelNames.OrderEntry]: 'panel.orderEntry',
    [PanelNames.AdvancedOrderEntry]: 'panel.orderEntry',
    [PanelNames.ChartPanel]: 'panel.chart',
    [PanelNames.InformerPanel]: 'panel.informer',
    [PanelNames.AlertPanel]: 'panel.alert',
    [PanelNames.CreateAlertPanel]: 'panel.alert',
    [PanelNames.MarketDepthPanel]: 'panel.level2',
    [PanelNames.TSPanel]: 'panel.timeSales',
    [PanelNames.PositionsPanel]: 'panel.positions',
    [PanelNames.OrdersPanel]: 'panel.orders',
    [PanelNames.OrderHistoryPanel]: 'panel.orderHistory',
    [PanelNames.FilledOrdersPanel]: 'panel.trades',
    [PanelNames.EventsPanel]: 'panel.log',
    [PanelNames.ReportsPanel]: 'ribbon.tools.reports',
    [PanelNames.ProductsPanel]: 'ribbon.tools.products',
    [PanelNames.AccountDetailsPanel]: 'panel.AccountDetailsPanel',
    [PanelNames.SymbolInfoPanel]: 'panel.instrumentsInfo',
    [PanelNames.AssetBalancesPanel]: 'panel.accounts',
    [PanelNames.GridPanel]: 'ribbon.tools.grid',
    [PanelNames.SavedOrdersPanel]: 'panel.savedOrders',
    [PanelNames.StatementPanel]: 'panel.statement',
    [PanelNames.FullLogsPanel]: 'ribbon.tools.full_logs',
    [PanelNames.MultiTimeSalesPanel]: 'Externalpanels.MultiTimeAndSales.Header',
    [PanelNames.AssetsPanel]: 'panel.assets',
    [PanelNames.PositionsBalancePanel]: 'panel.PositionsBalance',
    [PanelNames.NewsPanel]: 'panel.news',
    [PanelNames.PortfolioSummary]: 'panel.portfolioSummary',
    [PanelNames.RiskCalculator]: 'panel.riskCalculator',
    [PanelNames.AlgorithmMarketConsensusPanel]: 'panel.AlgorithmMarketConsensusPanel',
    [PanelNames.GainersLosersPanel]: 'panel.GainersLosersPanel',
    [PanelNames.HighLowPanel]: 'panel.HighLowPanel',
    [PanelNames.ClosePositionsMutually]: 'panel.ClosePositionsMutually',
    [PanelNames.HeatmapPanel]: 'panel.HeatmapPanel'
};

export enum ControlsTypes {
    CreateAlertAccountLookup = 'CreateAlertAccountLookup',
    CreateAlertWidget = 'CREATEALERTWIDGET',
    CreateAlertMessageSelector = 'CREATE_ALERT_MESSAGE_SELECTOR',
    InstrumentTotalInfo = 'INSTRUMENTTOTALINFO',
    TerceraChartToolsPanel = 'TerceraChartToolsPanel',
    OEQuote1Viewer = 'OEQuote1Viewer',
    OEAccountLookup = 'OEAccountLookup',
    TerceraAccountLookup = 'TerceraAccountLookup',
    TerceraLevel1Panel = 'TERCERALEVEL1PANEL',
    TerceraTimeZoneSelector = 'TERCERA_TIME_ZONE_SELECTOR',
    TerceraTicketViewer = 'TERCERA_TICKET_VIEWER'
}

export enum ScreensNames {
    // TODO. Remove.
    ModifyScreen = 'MODIFYSCREEN',
    EditPositionScreen = 'EDITPOSITIONSCREEN',
    ClosePositionScreen = 'CLOSEPOSITIONSCREEN',
    ModifyPositionScreen = 'MODIFYPOSITIONSCREEN',
    ModifyOrderScreen = 'MODIFYORDERSCREEN',
    PositionExerciseRequestScreen = 'POSITIONEXERCISEREQUESTSCREEN',
    BrokerMessageScreen = 'BROKERMESSAGESCREEN',
    WithdrawalScreen = 'WITHDRAWALSCREEN'
}

export const PanelsWithAccountLookup = [
    PanelNames.AccountDetailsPanel,
    PanelNames.AdvancedOrderEntry,
    PanelNames.AssetsPanel,
    PanelNames.ChartPanel,
    PanelNames.CreateAlertPanel,
    PanelNames.IdeasPanel,
    PanelNames.MarketDepthPanel,
    PanelNames.MarginOEControl,
    PanelNames.PositionsBalancePanel,
    PanelNames.PortfolioPerformance,
    PanelNames.ReportsPanel,
    PanelNames.RiskCalculator,
    ScreensNames.WithdrawalScreen
];
